/**
 * 公用的国际化文件：<中文>
 *
 * 在html属性中的使用示例：（注意属性名字前要有冒号）
 * <el-tooltip :content="$t('c.notice')" placement="bottom">
 * 在html模版中的使用示例：
 * <span>{{ $t('c.welcome') }}</span>
 * 在js代码中的使用示例：
 * window.document.title = this.$t('c.projectTitle')
 * 支持动态属性示例：
 * {{ $t(`c.${scope.row.operationStatus}`) }}
 *
 * 注意1:
 *    公用的国际化标识是以'c.'开头,
 *    业务应用的国际化默认是以'm.'开头, 可以自行调整
 *    但是不可以使用c(公用的)和el(ElementUI的), 避免冲突
 * 注意2:
 *    属性名称使用首字母小写的驼峰格式命名, 或下划线分隔单词
 *    必须使用英文，禁止使用拼音及拼音简写
 *    尽量做到望文知义，可以长一些，再长一些，保证代码可阅读性
 *    正确：projectTitle, studentName, min_waiting_time
 *    正确：loginPasswordVerifyFailedAutoUnlockPeriod,即：登录密码验证失败自动解锁时长
 *    正确：login_collision_attack_failed_count,即：登录碰撞攻击失败次数
 *    错误：name(这是什么阿猫阿狗), shijian(拼音时间或是事件或是??), pyjx(我猜是拼音简写, 错! 正确答案, 嗯...让我想想)
 * @author luwei
 * @version 1.0.0, 2019-03-16
 */
export const c = {
  login: '登录',
  rememberMe: '记住我',
  welcome: '欢迎你',
  fullScreen: '全屏',
  exitFullScreen: '退出全屏',
  message: '消息',
  popIndentMenuBar: '展开/收起菜单树',
  exit: '退出',
  Logout: '退出登录',
  changePassword: '修改密码',
  profile: '个人设定',
  chinese: '中文',
  english: '英文',
  enterUsername: '请输入用户名',
  enterPassword: '请输入密码',
  enterIdentifyCode: '请输入验证码',
  enterCorrectIdentifyCode: '请输入正确的验证码',
  fuzzySearch: '模糊查询',
  more: '更多',
  success: '成功',
  failure: '失败',
  result: '结果',
  tips: '提示',
  list: '列表',
  related: '关联的',
  operationSuccess: '操作成功',
  search: {
    placeholder: '模糊查询',
    "enterSearch": "回车搜索",
    "existing": "已有",
    "parallelQueryConditions": "个条件并行查询",
    "multipleParallelQuery": "多个条件并行查",
    "advanced": "高级",
    "startDate": "开始日期",
    "endDate": "结束日期",
    "to": "至"
  },
  table: {
    operation: '操作',
    new: '新增',
    view: '查看',
    edit: '编辑',
    delete: '删除',
    deleteRelation: '删除关联',
    add: '添加',
    deleteRowConfirm: '确认禁用该记录吗?',
    forbid: '确认禁用该用户吗?',
    enable: '确认启用该用户吗?',
    deleteRelationRowConfirm: '确认删除该关联吗?',
    deleteBatchConfirm1: '确认删除已选中的',
    deleteBatchConfirm2: '条记录吗?',
    deleteBatchRelationConfirm2: '条关联吗?',
    pleaseSelectForDelete: '请勾选要删除的记录',
    pleaseSelectForEdit: '请勾选要批量编辑的记录',
    pleaseSelectForAdd: '请勾选要添加的关联',
    tip: {
      add: '添加关联',
      createNewRecord: '创建新记录',
      deleteBatchRecord: '批量删除勾选的记录',
      deleteBatchRelation: '批量删除勾选的关联',
      editBatchRecord: '批量编辑勾选的记录',
      searchFields: '查询字段: '
    }
  },
  dialog: {
    save: '保存',
    submit: '提交',
    close: '关闭',
    publish: '发布',
    next: '下一步',
    back: '上一步',
    saveAndNext: '保存并下一步',
    saveSuccess: '保存成功'
  },
  form: {
    formMissInfo: '请补全缺失的信息!',
    the: '该',
    alreadyExists: '已经存在!',
    pleaseSelect: '请选择',
    pleaseInput: '请输入',
    maximumLength: '最大长度',
    rule: {
      pleaseMail: '请输入正确的邮箱地址',
      pleaseMobile: '请输入正确的手机号码',
      pleaseidNumber: '请输入正确的身份证号码',
      pleaseNumber: '请输入数值'
    }
  },
  audit: {
    mySecurityAudit: '我的安全审计',
    myAuditLog: '我的审计日志',
    operateTime: '操作时间',
    ipAddr: 'IP地址',
    operation: '操作',
    operator: '操作人',
    clientType: '客户端',
    operateType: '操作类型'
  },
  "friendshipLinks": {
    "friendshipLinks": "友情链接",
    "companyProfile": "公司介绍",
    "companyNews": "公司新闻",
    "joinUs": "加入我们",
    "contactUs": "联系我们"
  },
  "hostUnit": {
    "name": "北京诺君安信息技术股份有限公司",
    "officeAddressa": "北京市海淀区大钟寺东路168号 中嘉大厦301室",
    "icpNumber": "京ICP备10019042号-1",
    "hostUnit": "主办单位",
    "officeAddress": "办公地址",
  },
  "contactInformation": {
    "nationalConsultationPhone": "全国咨询电话",
    "nuoJunAnForeignAffairsApp": "诺君安外事APP",
    "nuoJunAnForeignAffairsMiniProgram": "诺君安外事小程序"
  },
  notice: {
    notice: '通知',
    originator: '发起方',
    title: '通知标题',
    message: '通知内容',
    receivers: '接收方',
    effectiveDate: '通知有效日期',
    startDate: '通知开始日期',
    endDate: '通知结束日期',
    confirmReceived: '已确认用户数',
    extra: '额外信息',
    status: '通知状态',
    normal: '正常',
    overdue: '过期',
    read: '已读',
    unread: '未读'
  },
  // 以下是审计日志类型
  SEC_LOGIN: '用户登录',
  SEC_LOGOUT: '用户登出',
  SEC_MODIFY_PASSWORD: '修改密码',
  SEC_RESET_PASSWORD: '重置密码',
  SYS_REQUEST: 'HTTP请求',
  BIZ_OPERATION: '业务操作',
  BIZ_TIMER_TASK: '定时业务任务'
  // 以上是审计日志类型
}
